var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstarlikeAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 270,
    rx: 20,
    fill: "#262945"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 270,
    rx: 20,
    fill: "url(#paint0_radial)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.046 146.12L159.193 181.184L167.613 206.053H210.564L187.046 146.12Z",
    fill: "#FF4FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.414 149.211L126.829 121.571L133.934 97.129C133.934 97.129 137.487 112.654 140.578 121.571L149.211 147.612L186.868 145.658L154.895 63.9474H112.618L79.1526 149.211H117.414Z",
    fill: "#FF4FBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9039 149.779L56.8421 206.053H99.7934L108.213 180.58L78.9039 149.779Z",
    fill: "#FF4FBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135) rotate(90) scale(270)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680921,
    stopColor: "#262945",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.316,
    height: 142.105,
    fill: "white",
    transform: "translate(56.8421 63.9474)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstarlikeAndroid);
export default __webpack_public_path__ + "static/media/icon_instarlike_android.11d68f074cbb373d2fd7ee167a9f8b56.svg";
export { ForwardRef as ReactComponent };